<div class="enkelleermiddelactivatieofgebruik">
  <canvas baseChart
          [data]="doughnutChartData"
          [options]="doughnutChartOptions"
          [plugins]="doughnutChartPlugins">
  </canvas>
</div>
